import React from 'react'
import { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';


function LoginTile({ sendValueBack }) {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");


    const closeLoginTile = (sts) => {
        sendValueBack(sts);
    }

    const onChangeUsername = (e) => {
        const username = e.target.value;
        setUsername(username);
        setErrorMessage("");
    };

    const onChangePassword = (e) => {
        const password = e.target.value;
        setPassword(password);
        setErrorMessage("");
    };

    const handleLoginCancel = (e) => {
        setErrorMessage("");
        setUsername("");
        setPassword("");
        closeLoginTile(e);

    }
    const handleLogin = (e) => {

        let tmpData = JSON.stringify({
            username: username,
            password: password
        });

        axios.post("/api/v1/auth/signin", tmpData, {
            headers: { 'Content-type': 'application/json' }
        })
            .then((response) => {
                if (response.data.accessToken) {
                    if (response.data.active) {
                        handleLoginCancel(true);
                        if (window.location.pathname === '/Logout' || window.location.pathname.startsWith("/verify")) {
                            window.location.href = '/'
                        } else {
                            window.location.reload();
                        }
                    } else {
                        setErrorMessage("Your account has not yet been verified.");
                    }
                }
            })
            .catch((err) => {
                if (err.response.status === 401) {
                    setErrorMessage("Unable to log in with these credentials");
                }
            });
    }


    return (
        <div>
            <div className="overlay">
                <div className="popup">
                    <h3>Login</h3>
                    <input type="text" name="username" placeholder="User Name" onChange={onChangeUsername} />
                    <input type="password" name="password" placeholder="Password" onChange={onChangePassword} />
                    <br />
                    <div className="errorMessage">
                        {errorMessage ? errorMessage : ""}
                    </div>
                    <button onClick={() => handleLogin()}>Login</button>
                    <button onClick={() => handleLoginCancel(false)}>Cancel</button>
                    <Link to="/Register.html">Register</Link>
                </div>
            </div>
        </div>
    )
}

export default LoginTile
